import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-dv-fiscaal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-dv-fiscaal.component.html',
  styleUrl: './tekst-dv-fiscaal.component.scss',
})
export class TekstDvFiscaalComponent {}
